import { motion } from "framer-motion";

import toyota from "@/assets/partners/toyota_logo.svg";
import mahindra from "@/assets/partners/mahindra_logo.png";
import lava from "@/assets/partners/lava_logo.svg";
import gpj from "@/assets/partners/gpj_logo.png";
import talisman from "@/assets/partners/talisman_logo.png";
import farmtoplate from "@/assets/partners/farm_to_plate_logo.jpg";
import buildx from "@/assets/partners/buildx_homes_logo.png";
import biz2x from "@/assets/partners/biz2x_logo.jpg";
import reckon from "@/assets/partners/reckon_logo.jpg";
import shilpa from "@/assets/partners/shilpa_logo.png";
import mahindra_univ from "@/assets/partners/mahindra_university_logo.png";
import margsoft from "@/assets/partners/margsoft_logo.png";
import square_boat from "@/assets/partners/square_boat_logo.png";
import sumukha from "@/assets/partners/sumukha_logo.png";
import tata from "@/assets/partners/tata_logo.svg";

const clients = [
  { name: "Toyota", url: toyota },
  { name: "Mahindra", url: mahindra },
  { name: "Lava", url: lava },
  { name: "GPJ", url: gpj },
  { name: "Talisman", url: talisman },
  { name: "Farm to Plate", url: farmtoplate },
  { name: "BuildXHomes", url: buildx },
  { name: "Biz2X", url: biz2x },
  { name: "Reckon", url: reckon },
  { name: "Shilpa", url: shilpa },
  { name: "Mahindra University", url: mahindra_univ },
  { name: "Margsoft", url: margsoft },
  { name: "Squareboat", url: square_boat },
  { name: "Sumukha", url: sumukha },
  { name: "Tata", url: tata },
];

export default function ClientMarquee() {
  // Duplicate multiple times for a truly seamless loop on all screen sizes
  const duplicatedClients = [...clients, ...clients, ...clients, ...clients];

  return (
    <div className="py-8 bg-transparent overflow-hidden" data-testid="client-marquee">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl mb-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center text-slate-500 font-medium text-xs tracking-wider uppercase"
        >
          Trusted by 50+ Businesses Worldwide
        </motion.p>
      </div>

      <div className="relative">
        {/* Translucent gradient overlays to let background colors filter through */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-50/10 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-50/10 to-transparent z-10" />

        {/* Marquee container - w-max ensures it doesn't wrap or shrink */}
        <div className="flex w-max animate-marquee-fast">
          {duplicatedClients.map((client, index) => (
            <div
              key={`${client.name}-${index}`}
              className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center"
            >
              <img
                src={client.url}
                alt={client.name}
                className="h-10 md:h-12 w-auto max-w-[140px] object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
